/**
 * Interaction Service
 * Handles pure logic functionality and React hooks related to user interaction
 */
import { useState } from 'react';

/** Map point selection callback */
export const useMapPointSelect = () => {
  const [mapPointSelectCallback, setMapPointSelectCallback] = useState(null);
  const setMapPointSelect = (callback) => setMapPointSelectCallback(() => callback);
  const clearMapPointSelect = () => setMapPointSelectCallback(null);
  return { mapPointSelectCallback, setMapPointSelect, clearMapPointSelect };
};

/** ✅ Allow adding points by clicking the map in Custom Path mode */
export const isMapClickAddPointEnabled = (currentMode) => currentMode === 'Setup Points';

/** Selecting existing points is also allowed in Custom Path */
export const isPointSelectionEnabled = (currentMode) => currentMode === 'Custom Path';
